<template>
  <div class="product-interpretations m-t-20">
    <SfTable>
      <SfTableHeading>
        <SfTableHeader v-for="header in tableHeaders" :key="header">
          {{ $t(header) }}
        </SfTableHeader>
      </SfTableHeading>
      <SfTableRow
        v-for="(interpretation, index) in flatInterpretations"
        :key="`${interpretation.Sku}-${index}`"
                :style="{ background: !interpretation.Leaf ? 'rgb(242 242 242)' : 'inherit'}"

      >
        <SfTableData v-for="header in tableHeaders" :key="header"
          :style="{
          'padding-left':
            `${interpretation.index && header === 'Sku' ? interpretation.index * 10 : 0}px`
          }"
        >
        <div
          class="icon-wrapper"
          :style="{
          'padding-left':
            `${header === 'Sku' ? 25 : 0}px`
          }"
        >
          <template v-if="header === 'Sku' && !interpretation.Leaf ">
            <ArrowRight class="group-icon"/>
          </template>
          {{interpretation[header] }}
        </div>
        </SfTableData>
      </SfTableRow>
    </SfTable>
  </div>
</template>

<script>
import { SfTable } from '@storefront-ui/vue';
import ArrowRight from 'vue-material-design-icons/ChevronRight.vue';
import _ from 'lodash';

const getMembers = index => (member) => {
  if (!member.Children || !member.Children.length) {
    return { ...member };
  }
  return [member, _.flatMapDeep(
    member.Children.map(item => ({ ...item, index })), getMembers(index + 1),
  )];
};

export default {
  name: 'ProductInterpretationsFlat',
  components: {
    SfTable,
    ArrowRight,
  },
  props: {
    interpretations: {
      type: Array,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    flatInterpretations() {
      return _.flatMapDeep(
        this.interpretations.map((item) => ({ ...item, index: 0 })), getMembers(1),
      );
    },
  },
  data() {
    return {
      tableHeaders: [
        'Sku',
        'Name',
        'Status',
        'DateOfEndOfLifeDate',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.acc-auto {
  overflow-x: auto;
}
.group-icon {
  position: absolute;
  left: 0
}
.icon-wrapper {
  position: relative;
}
</style>
